/**
 * AlertsNotification.jsx
 * Created by michaelbray on 2/13/18.
 */

import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import cx from 'classnames';

import * as alertLevels from '../../../helpers/alertLevelsHelper';
import getLocationParams from '../../../helpers/getLocationParams';
import AlertsByLevel from './AlertsByLevel';


export default function AlertsNotification({ alerts, fetchAlerts, autoFetchForLocationChange, isInline }) {
    const location = useLocation();

    useEffect(() => {
        if (autoFetchForLocationChange) {
            const locationParams = getLocationParams(location);
            fetchAlerts(locationParams);
        }
    }, [location, autoFetchForLocationChange, fetchAlerts]);

    if (!alerts || alerts.length === 0) {
        return null;
    }

    // Remove alerts that have been canceled
    const filteredAlerts = alerts.filter((item) => !item.canceled_at);

    const infoAlerts = filteredAlerts.filter((a) => a.alert_level === alertLevels.INFO_ALERT_LEVEL);
    const warningAlerts = filteredAlerts.filter((a) => a.alert_level === alertLevels.WARNING_ALERT_LEVEL);
    const successAlerts = filteredAlerts.filter((a) => a.alert_level === alertLevels.SUCCESS_ALERT_LEVEL);
    const errorAlerts = filteredAlerts.filter((a) => a.alert_level === alertLevels.ERROR_ALERT_LEVEL);

    return (
        <div
            className={cx('nav-header-alerts', {
                'is-inline': isInline
            })}>
            <AlertsByLevel alerts={errorAlerts} level={alertLevels.ERROR_ALERT_LEVEL} />
            <AlertsByLevel alerts={warningAlerts} level={alertLevels.WARNING_ALERT_LEVEL} />
            <AlertsByLevel alerts={infoAlerts} level={alertLevels.INFO_ALERT_LEVEL} />
            <AlertsByLevel alerts={successAlerts} level={alertLevels.SUCCESS_ALERT_LEVEL} />
        </div>
    );
}

AlertsNotification.propTypes = {
    alerts: PropTypes.array,
    fetchAlerts: PropTypes.func,
    autoFetchForLocationChange: PropTypes.bool,
    isInline: PropTypes.bool
};

AlertsNotification.defaultProps = {
    alerts: [],
    fetchAlerts: () => true,
    autoFetchForLocationChange: false,
    isInline: false
};
